/* eslint-disable @typescript-eslint/no-shadow,no-underscore-dangle,@typescript-eslint/no-unused-expressions */

import { EVENTS } from '../../../../app/constants/events';

xplenty.controller('ComponentEditorMultiEdgesTransformationController', [
  '$scope',
  '$controller',
  '$timeout',
  '$rootScope',

  function ($scope, $controller, $timeout, $rootScope) {
    const components = [];
    // true for flagging the method to give back schemas by `order` property
    $scope.parentSchemas = $scope._default.getParentComponentsSchemas(true);

    _.each($scope.parentSchemas, function (parentSchema) {
      if (parentSchema && parentSchema.id) {
        const component = $scope._default.package.getComponentById(parentSchema.id);
        components.push(component);
      } else {
        components.push(null);
      }
    });

    $scope.components = components;

    angular.extend(this, $controller('ComponentsOrderStep', { $scope }));
    angular.extend(this, $controller('ComponentFormStep', { $scope }));

    let componentNameValid = false;
    let componentIsValid = true;
    $scope.isComponentValid = function (isValid = true) {
      $timeout(function () {
        componentIsValid = isValid;
        const valid =
          componentNameValid &&
          !($scope.componentOrderStep && !$scope.componentOrderStep.validate()) &&
          !($scope.componentFormStep && !$scope.componentFormStep.validate()) &&
          componentIsValid;

        $rootScope.$broadcast(EVENTS.DESIGNER_COMPONENT_SAVE_DISABLE, !valid);
      });
    };

    $scope.$on(EVENTS.DESIGNER_COMPONENT_NAME_VALID, function (event, valid) {
      componentNameValid = valid;
    });

    if (!$scope.componentOrderStep.valid) {
      $scope.componentFormStep.lock = true;
      $scope.componentFormStep.valid = false;
    } else {
      $scope.componentFormStep.active = true;
    }

    let timeoutPromise;

    $scope.$watch(
      '[valid, parentSchemas]',
      function () {
        timeoutPromise && $timeout.cancel(timeoutPromise);
        timeoutPromise = $timeout(function () {
          $scope.isComponentValid();
          timeoutPromise = null;
        });
      },
      true,
    );

    $timeout(function () {
      $scope.isComponentValid();
    }, 500);

    $scope.$on(EVENTS.COMPONENTS_ORDER_EDITOR_SWITCH, function (event, components) {
      $scope.parentSchemas.length = 0;
      _.each(components, function (component) {
        if (component) $scope.parentSchemas.push(component.getSchema());
        else $scope.parentSchemas.push(null);
      });
    });
  },
]);
